import React, { CSSProperties, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'reactstrap';
import { AuditedCategory, defaultEndDate, defaultStartDate } from './auditData';
import AuditSummaryWrapper from './AuditSummaryWrapper';
import AuditDatesPicker from './AuditDatesPicker';
import UserAuditEvents from './UserAuditEvents';
import { ModalProps } from 'reactstrap/types/lib/Modal';

interface AuditTrailModalProps extends ModalProps {
  user_guid: string;
}

const allowedCategories = new Set([AuditedCategory.cases, AuditedCategory.appointments, AuditedCategory.tasks]);

const AuditTrailModal = ({ user_guid, ...restProps }: AuditTrailModalProps) => {
  const { t } = useTranslation('common');
  const [eventsStartDate, setEventsStartDate] = useState(defaultStartDate);
  const [eventsEndDate, setEventsEndDate] = useState(defaultEndDate);

  return (
    <Modal size="xl" centered keyboard={false} data-testid="audit-trail-modal" {...restProps}>
      <ModalBody>
        <p style={styles.title}>{t('System Audit')}</p>
        <AuditDatesPicker
          eventsStartDate={eventsStartDate}
          eventsEndDate={eventsEndDate}
          setEventsStartDate={setEventsStartDate}
          setEventsEndDate={setEventsEndDate}
        />
        <AuditSummaryWrapper
          user_guid={user_guid}
          allowedCategories={allowedCategories}
          start_date={eventsStartDate}
          end_date={eventsEndDate}
        />
        <p style={styles.title}>{t('User Audit Events')}</p>
        <UserAuditEvents id={user_guid} start_date={eventsStartDate} end_date={eventsEndDate} />
      </ModalBody>
    </Modal>
  );
};

export default AuditTrailModal;

const styles = {
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '1.5rem'
  } as CSSProperties
};
